<template>
  <div class="d-flex flex-column align-items-center" style="background-color: black">
    <div class="language-selector-wrapper">
      <LanguageSelector :current-language="currentLanguage" :translations="translations" @change="changeLanguage" />
    </div>

    <div class="col-12 col-sm-8 col-md-6 col-lg-5 col-xl-3 vue-container">
      <router-view/>
    </div>
  </div>
</template>

<script>
import {setBrandConfig} from "@/functions/setBrandConfig";
import {mapMutations, mapState} from "vuex";
import addGTM from "@/functions/addGTM";
import LanguageSelector from "@/views/LanguageSelector.vue";
import {getBrandConfig} from "@/brand";

export default {
  components: {LanguageSelector},
  data(){
    return {
      currentLanguage: 'en',
      brandConfig: getBrandConfig('blg-en')
    }
  },
  computed: {
    ...mapState(['brandConfig']),
    translations() {
      return this.brandConfig.translations || {}
    },
  },
  async beforeMount() {
    setBrandConfig();
    this.setTabName()
    this.setFavicon()
    if (this.brandConfig.gtmIdentifier) addGTM(this.brandConfig.gtmIdentifier);
  },
  methods: {
    ...mapMutations(['setBrandConfig']),
    setTabName() {
      document.title = this.brandConfig.tabTitle;
    },
    changeLanguage(language) {
      console.log('[Page] Language changed to:', language)
      this.currentLanguage = language
      const languageBrand = language === 'am' ? getBrandConfig('blg-am') : getBrandConfig('blg-en');
      this.setBrandConfig(languageBrand);
    },

    setFavicon() {
      this.$nextTick(() => {
        const faviconPath = require(`@/brand/${this.brandConfig.brand}/assets/logo.png`);

        const link = document.querySelector("link[rel~='icon']") || document.createElement('link');
        link.rel = 'icon';
        link.type = 'image/png';
        link.href = faviconPath;

        if (!link.parentNode) {
          document.head.appendChild(link);
        }
      });
    },
  }
}
</script>

<style>
.language-selector-wrapper {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 10;
}

.rtl .language-selector-wrapper {
  right: auto;
  left: 16px;
}

</style>
